// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Meta_wrapper__Jw9nY","left":"Meta_left__yQ0gu","center":"Meta_center__g8Tyq","footer":"Meta_footer__1_CPc"};